import { apiV2, errorHandler } from './index';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import {
  API_ERROR,
  FETCH_ALL_SUBCATEGORIES,
  FETCH_ALL_SUBCATEGORIES_START,
  FETCH_ONE_SUBCATEGORY,
  FETCH_ONE_SUBCATEGORY_START,
  CLEAR_ALL_SUB_CATEGORIES,
} from '../constants/ActionTypes';

export function fetchAllSubCategories(is_audiobook = 0, is_quick_tap = null) {
  return function (dispatch) {
    dispatch({
      type: FETCH_ALL_SUBCATEGORIES_START
    });

    const params = {};
    if (is_audiobook !== null) {
      params.is_audiobook = is_audiobook;
    }
    if (is_quick_tap !== null) {
      params.is_quick_tap = is_quick_tap;
    }

    apiV2.get('/subcategories', { params })
      .then((response) => {
        const items = response.data.objects || [];
        const objects = items.reduce((acc, el) => {
          acc[el.subcategory_id] = el;
          return acc;
        }, {});

        dispatch({
          type: FETCH_ALL_SUBCATEGORIES,
          payload: objects,
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function fetchOneSubcategory(subcategory_id) {
  return function (dispatch) {
    dispatch({ type: FETCH_ONE_SUBCATEGORY_START });

    return apiV2.get(`/subcategories/${subcategory_id}`)
      .then((response) => {
        dispatch({
          type: FETCH_ONE_SUBCATEGORY,
          payload: response.data
        });
        return response.data;
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function clearAllSubCategories() {
  return function (dispatch) {
    dispatch({
      type: CLEAR_ALL_SUB_CATEGORIES
    });
  };
}

export function addEditSubCategory(options, onSuccess) {
  return function (dispatch) {
    const subcategoryData = typeof options.subcategory_json === 'string'
      ? JSON.parse(options.subcategory_json)
      : options.subcategory_json;

    const quotes = options.quotes_json
      ? (typeof options.quotes_json === 'string'
        ? JSON.parse(options.quotes_json)
        : options.quotes_json)
      : undefined;

    const sessions = options.session_ids_json
      ? (typeof options.session_ids_json === 'string'
        ? JSON.parse(options.session_ids_json)
        : options.session_ids_json)
      : undefined;

    const isUpdate = !!subcategoryData.subcategory_id;

    const payload = {
      category_id: options.category_id,
      subcategory_title: subcategoryData.subcategory_title,
      subcategory_description: subcategoryData.subcategory_description,
      subcategory_explore_term: subcategoryData.subcategory_explore_term,
      subcategory_image: subcategoryData.subcategory_image,
      subcategory_is_book: subcategoryData.subcategory_is_book,
      subcategory_grayscale_image: subcategoryData.subcategory_grayscale_image,
      subcategory_is_active: subcategoryData.subcategory_is_active,
      subcategory_text_page_url: subcategoryData.subcategory_text_page_url,
      subcategory_text_image_url: subcategoryData.subcategory_text_image_url,
      subcategory_is_dark_mode: subcategoryData.subcategory_is_dark_mode,
      subcategory_is_quick_tap: subcategoryData.subcategory_is_quick_tap,
      subcategory_is_new: subcategoryData.subcategory_is_new,
      subcategory_deep_link_image: subcategoryData.subcategory_deep_link_image,
      subcategory_deep_link_android: subcategoryData.subcategory_deep_link_android,
      subcategory_deep_link_ios: subcategoryData.subcategory_deep_link_ios,
    };

    if (quotes) {
      payload.quotes = quotes;
    }

    if (isUpdate && sessions) {
      payload.sessions = sessions;
    }

    const request = isUpdate
      ? apiV2.put(`/subcategories/${subcategoryData.subcategory_id}`, payload)
      : apiV2.post('/subcategories', payload);

    return request
      .then((response) => {
        return Swal.fire({
          icon: 'success',
          title: 'Saved!',
          timer: 1000,
        }).then(() => {
          onSuccess?.();
          return response;
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function addEditAudioBook(options, onSuccess) {
  return function (dispatch) {
    const subcategoryData = typeof options.subcategory_json === 'string'
      ? JSON.parse(options.subcategory_json)
      : options.subcategory_json;

    const quotes = options.quotes_json
      ? (typeof options.quotes_json === 'string'
        ? JSON.parse(options.quotes_json)
        : options.quotes_json)
      : undefined;

    const sessions = options.session_ids_json
      ? (typeof options.session_ids_json === 'string'
        ? JSON.parse(options.session_ids_json)
        : options.session_ids_json)
      : undefined;

    const isUpdate = !!subcategoryData.subcategory_id;

    const payload = {
      category_id: options.category_id,
      subcategory_title: subcategoryData.subcategory_title,
      subcategory_description: subcategoryData.subcategory_description,
      subcategory_explore_term: subcategoryData.subcategory_explore_term,
      subcategory_image: subcategoryData.subcategory_image,
      subcategory_is_book: 1,
      subcategory_grayscale_image: subcategoryData.subcategory_grayscale_image,
      subcategory_is_active: subcategoryData.subcategory_is_active,
      subcategory_text_page_url: subcategoryData.subcategory_text_page_url,
      subcategory_text_image_url: subcategoryData.subcategory_text_image_url,
      subcategory_is_dark_mode: subcategoryData.subcategory_is_dark_mode,
      subcategory_is_quick_tap: subcategoryData.subcategory_is_quick_tap,
      subcategory_is_new: subcategoryData.subcategory_is_new,
      subcategory_deep_link_image: subcategoryData.subcategory_deep_link_image,
      subcategory_deep_link_android: subcategoryData.subcategory_deep_link_android,
      subcategory_deep_link_ios: subcategoryData.subcategory_deep_link_ios,
    };

    if (quotes) {
      payload.quotes = quotes;
    }

    if (isUpdate && sessions) {
      payload.sessions = sessions;
    }

    const request = isUpdate
      ? apiV2.put(`/subcategories/${subcategoryData.subcategory_id}`, payload)
      : apiV2.post('/subcategories', payload);

    request
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Saved!',
          timer: 1000,
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function deleteSubCategory(subcategory_id, onSuccess) {
  return function (dispatch) {
    apiV2.delete(`/subcategories/${subcategory_id}`)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Subcategory Deleted!',
          timer: 1000,
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}
